var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLazarusLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 40,
    viewBox: "0 0 44 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5645 18.2711L3.80376 21.2179C1.0677 21.9678 -0.557693 24.8415 0.176252 27.6373L12.9635 24.1364C15.2302 23.5158 17.1625 22.001 18.3349 19.9237C19.5089 17.848 19.8255 15.3791 19.2182 13.0645L15.7921 0C13.056 0.749958 11.4306 3.62369 12.1646 6.41945L15.0484 17.415L14.5645 18.2711Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.245 18.2711L40.0058 21.2179C42.7418 21.9678 44.3672 24.8415 43.6333 27.6373L30.8461 24.1364C28.5793 23.5158 26.647 22.001 25.4746 19.9237C24.3006 17.848 23.984 15.3791 24.5913 13.0645L28.0175 0C30.7535 0.749958 32.3789 3.62369 31.645 6.41945L28.7611 17.415L29.245 18.2711Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4184 30.4082L13.5367 38.452C11.5313 40.4978 8.28375 40.4961 6.28164 38.447L15.6476 28.8883C17.3071 27.1943 19.5592 26.2436 21.9056 26.2452C24.2519 26.2452 26.5025 27.2009 28.1603 28.8966L37.5149 38.4669C35.5095 40.5127 32.262 40.511 30.2599 38.4619L22.3878 30.4082H21.4184Z",
    fill: "#F2F2F2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLazarusLogo);
export default __webpack_public_path__ + "static/media/LazarusLogo.c6790f32c030c0df2da10926b63c12a2.svg";
export { ForwardRef as ReactComponent };